import React, { Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
// Lazy load all below-fold sections to reduce initial bundle
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PainPointsSection = lazy(() => import('./components/PainPointsSection').then(m => ({
  default: m.PainPointsSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const MasterPackSection = lazy(() => import('./components/MasterPackSection').then(m => ({
  default: m.MasterPackSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const CostComparisonSection = lazy(() => import('./components/CostComparisonSection').then(m => ({
  default: m.CostComparisonSection
})));
const FinalCtaSection = lazy(() => import('./components/FinalCtaSection').then(m => ({
  default: m.FinalCtaSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  const testimonials1 = [{
    initials: 'MG',
    quote: 'En tres semanas mi hijo empezó a nombrar lo que siente en lugar de explotar. No lo puedo creer. Este material hace lo que mil conversaciones no lograron.',
    name: 'María G.',
    location: 'Bogotá',
    role: 'Mamá de adolescente de 14 años'
  }, {
    initials: 'LP',
    quote: 'Lo usé en el aula y el cambio fue inmediato. Los chicos por fin tienen palabras para lo que les pasa. El Tomo del Volcán es el favorito de todos.',
    name: 'Laura P.',
    location: 'Buenos Aires',
    role: 'Docente de secundaria'
  }, {
    initials: 'RM',
    quote: 'Mi hija de 16 años lo abrió sola. Sola. Y me pidió que lo hiciéramos juntas. Eso no tenía precio.',
    name: 'Rosa M.',
    location: 'Santiago de Chile',
    role: 'Mamá de adolescente'
  }];
  const testimonials2 = [{
    initials: 'CR',
    quote: 'El Token System cambió la dinámica de casa completamente. Mi hijo hace los ejercicios solo porque quiere ganar tokens. Nunca pensé que iba a funcionar tan rápido.',
    name: 'Cecilia R.',
    location: 'Mendoza',
    role: 'MegaPack + Master-Pack',
    highlight: 'MegaPack + Master-Pack'
  }, {
    initials: 'RM',
    quote: 'Las Cartas de Conexión las uso al inicio de clase. En dos semanas el grupo habla de emociones como si siempre lo hubieran hecho. Es increíble.',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    role: 'Docente de secundaria'
  }, {
    initials: 'SC',
    quote: 'Mi hija de 15 completó el Tomo 1 sola en una semana. Después me pidió que lo hiciéramos juntas desde el principio. Lloramos juntas en varios ejercicios. Vale cada peso.',
    name: 'Sofía C.',
    location: 'Santiago',
    role: 'Mamá de dos adolescentes'
  }, {
    initials: 'PA',
    quote: 'Lo recomiendo a todas las familias de mis pacientes adolescentes. Es el puente entre la consulta y el hogar que siempre necesité.',
    name: 'Pablo A.',
    location: 'Medellín',
    role: 'Psicólogo escolar'
  }];
  // Fallback for lazy sections — invisible, no layout shift
  const sectionFallback = <div className="min-h-[200px]" data-id="element-0" />;
  return <div className="min-h-screen bg-navy-900 text-slate-200 font-inter selection:bg-blue-500/30 overflow-x-hidden" data-id="element-1">
      {/* Critical above-fold — loaded eagerly */}
      <HeroSection data-id="element-2" />
      <StatsBar data-id="element-3" />

      {/* Below-fold — lazy loaded with framer-motion */}
      <Suspense fallback={sectionFallback} data-id="element-4">
        <TestimonialsSection title="Lo que dicen quienes ya lo tienen" testimonials={testimonials1} data-id="element-5" />
      </Suspense>

      <Suspense fallback={sectionFallback} data-id="element-6">
        <PainPointsSection data-id="element-7" />
      </Suspense>

      <Suspense fallback={sectionFallback} data-id="element-8">
        <TomosSection data-id="element-9" />
      </Suspense>

      <Suspense fallback={sectionFallback} data-id="element-10">
        <BonusesSection data-id="element-11" />
      </Suspense>

      <Suspense fallback={sectionFallback} data-id="element-12">
        <PricingSection data-id="element-13" />
      </Suspense>

      <Suspense fallback={sectionFallback} data-id="element-14">
        <MasterPackSection data-id="element-15" />
      </Suspense>

      <Suspense fallback={sectionFallback} data-id="element-16">
        <TestimonialsSection title="❤️ MÁS FAMILIAS Y DOCENTES QUE YA LO TIENEN" testimonials={testimonials2} darker={true} data-id="element-17" />
      </Suspense>

      <Suspense fallback={sectionFallback} data-id="element-18">
        <GuaranteeSection data-id="element-19" />
      </Suspense>

      <Suspense fallback={sectionFallback} data-id="element-20">
        <FaqSection data-id="element-21" />
      </Suspense>

      <Suspense fallback={sectionFallback} data-id="element-22">
        <CostComparisonSection data-id="element-23" />
      </Suspense>

      <Suspense fallback={sectionFallback} data-id="element-24">
        <FinalCtaSection data-id="element-25" />
      </Suspense>

      <Suspense fallback={null} data-id="element-26">
        <Footer data-id="element-27" />
      </Suspense>

      <Suspense fallback={null} data-id="element-28">
        <SocialProofPopup data-id="element-29" />
      </Suspense>
    </div>;
}